var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 7.99999C14.4001 11.0928 11.5345 13.6 8.0001 13.6C6.86414 13.6048 5.74374 13.3358 4.7337 12.816L1.6001 13.6L2.6705 11.1016C1.9945 10.2136 1.6001 9.14719 1.6001 7.99999C1.6001 4.90719 4.4657 2.39999 8.0001 2.39999C11.5345 2.39999 14.4001 4.90719 14.4001 7.99999ZM5.6001 7.19999H4.0001V8.79999H5.6001V7.19999ZM12.0001 7.19999H10.4001V8.79999H12.0001V7.19999ZM7.2001 7.19999H8.8001V8.79999H7.2001V7.19999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.fcef042a410a705275354ed15c8c1228.svg";
export { ForwardRef as ReactComponent };